module.exports = __webpack_public_path__ + "static/media/Zalo.c7885df5.svg";